import { List } from '@mui/material';

import { selectCurrentUser } from '@src/store/auth/auth-selectors';
import { useAppSelector } from '@src/store/store';

import useLocales from '@src/locales/use-locales';
import { getAllowedRoutes } from '@src/routes/utils/navigation';

import useNavItems from '../../config-navigation';
import NavGroup from '../nav-group';

const NavList = () => {
  const user = useAppSelector(selectCurrentUser);
  const { t } = useLocales();

  const { role } = user!;

  const navItems = useNavItems();
  const filteredNavItems = getAllowedRoutes(navItems, role);

  return (
    <List
      aria-label={t('ariaLabels.navList')}
      sx={{
        p: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
      }}
    >
      {filteredNavItems.map((entry) => (
        <NavGroup key={entry.id} group={entry} />
      ))}
    </List>
  );
};

export default NavList;
